module.exports = __webpack_public_path__ + "img/Texas Map asset.c15e09cc.png";